module.exports = __webpack_public_path__ + "static/media/simbolo-festival-online.58e6d1d6.png";